import { largeTabletMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import RichText from '../rich-text/RichText';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (${largeTabletMax}) {
    margin: 0 0 15px;
    flex-direction: column;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 30px;
  flex-wrap: wrap-reverse;
  gap: 30px;

  @media (${largeTabletMax}) {
    margin-bottom: 15px;
  }
`;

export const SummaryOptions = styled.div`
  display: flex;
  gap: 15px;

  button,
  a,
  & > div {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: inherit;

    svg {
      margin-right: 10px;
    }

    &:hover {
      text-decoration: underline;
      color: ${(props) => props.theme.textLight};
    }
  }

  @media (${mobileXXLargeMax}) {
    flex-wrap: wrap;
  }
`;

export const SummaryText = styled(RichText)<{ $hasBriefText: boolean }>`
  margin-top: 15px;
  > :first-child {
    margin-top: 0;
  }
  > :last-child {
    margin-bottom: 0;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  ${({ $hasBriefText }) =>
    $hasBriefText &&
    css`
      padding-top: 15px;
      border-top: 1px solid ${({ theme }) => theme.black};
    `}
`;
